import * as React from "react";
import { Close } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Swal from "sweetalert2";

import store from "app/store/store";
import { AnanseApiService } from "app/services/Ananse/AnanseApiService";
import NoarLogo from "assets/components/NoarLogo";
import { formatedDate } from "utils";
import { useTranslation } from "_metronic/i18n/language";
import { useRTL } from "themes/RTLProvider/RTLProvider";
import { QuizType } from "app/types";
import { ParamsI } from "../CognitiveResults/cognitive-result-view";
import PrintResult from "../../Result/components/PrintResult";

type Props = {
  openPDF: boolean;
  setOpenPDF: (isOpen: boolean) => void;
  data: any;
  accountId: ParamsI | undefined;
  account: any;
  totalScore: number;
};
const api = new AnanseApiService();

export default function ModalResultPDF({
  openPDF,
  setOpenPDF,
  data,
  account,
  totalScore,
}: Props) {
  const translate = useTranslation();
  const isRtl = useRTL();
  const valueTransformIfRtl = isRtl ? "scaleX(-1)" : undefined;
  const { auth } = store.getState();
  const handleClose = () => {
    setOpenPDF(false);
  };

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [results, setResults] = React.useState<Array<any>>([]);
  const dateNow = new Date();
  const replaceName = account?.name; //.replace(/\s+/g, "-");
  const namefile = `${replaceName}_${
    data?.testResultId
  }_${dateNow.toISOString()}`;

  const style = {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: windowWidth <= 900 ? "95%" : "95%",
    minWidth: "75%",
    height: "95%",
    bgcolor: "#FFF",
    color: "#000",
    boxShadow: 24,
    p: 4,
    borderRadius: 1,
    overflow: "auto",
  };

  React.useEffect(() => {
    loadRecords(fillResults);
  }, [data?.results]);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const loadRecords = async (cb?: () => void) => {
    if (cb) {
      cb();
    }
    try {
      await getQuizId(data?.results[0]?.quizId);
      const response = await api.makeHttpRequest({ url: "/question" });
      const result = await api.makeHttpRequest({
        url: `/question?PerPage=${response.total}`,
      });
      // setQuestions(result.data);
    } catch (error) {
      Swal.fire(
        translate("defaultMessages.error"),
        translate("defaultMessages.loadData"),
        "error",
      );
    }
  };

  const getQuizId = async (quizId: number) => {
    try {
      const response: QuizType = await api.makeHttpRequest({
        url: `/quiz/${quizId}`,
      });
    } catch (error) {
      console.error("error getQuizId: ", error);
    }
  };

  const getResultDetails = React.useCallback(async () => {
    try {
      const payload = {
        accountId: data?.results[0].accountId,
        testResultId: data?.testResultId,
        userId: data?.results[0].userId,
      };
      const reqBase = {
        method: "GET",
        url: `/quizanswerdetails/quizanswerdetails/${payload.testResultId}/${payload.userId}/${payload.accountId}`,
      };
      const response = await api.makeHttpRequest({
        ...reqBase,
      });
      // setResultDetail(response[0]);
    } catch (error) {
      console.error("getResultDetails", error);
    }
  }, [data]);

  React.useEffect(() => {
    getResultDetails();
  }, [getResultDetails]);

  const fillResults = () => {
    const dataResults: Array<any> = [];
    data?.results.forEach((value: any) => {
      const currentResult = dataResults.find(
        e => e.question === value.question,
      );
      if (!currentResult) {
        dataResults.push(value);
      }
    });
    setResults(dataResults);
  };

  const renderProfissional = () => {
    if (data?.results[0]?.doctor) {
      return (
        <h4 className="labels">
          <b>{translate("screenApp.results.title")}: </b>
          {data?.results[0]?.doctor}- <b>CRM: </b>
          {data?.results[0]?.professionalId}
        </h4>
      );
    }
    return "";
  };

  const _renderInfo = () => (
    <div className="tableClassification">
      <div>
        <div>
          <div className="headerPdf">
            <NoarLogo />
            <div className="containerTitle">
              <h3 className="title">
                {translate("screenApp_results_cognitiveTest")}
              </h3>
            </div>
          </div>
          <div className="containerForm">
            <table className="top">
              <tr className="top">
                <th className="top">
                  <div className="folha">
                    <h4 className="labels">
                      <b>{translate("screenApp.results.patient")}: </b>
                      {account?.name || ""}
                    </h4>
                    <h4 className="labels">
                      <b>{translate("screenApp.results.record")}: </b>
                      {account?.cpf}
                    </h4>
                    <h4 className="labels">
                      <b>DN: </b>
                      {formatedDate(account?.birthDate, true)}
                    </h4>
                    <h4 className="labels">
                      <b>{translate("screenApp.results.examLocation")}: </b>
                      {data?.results[0]?.location
                        ? data?.results[0]?.location
                        : ""}
                    </h4>
                  </div>
                </th>
                <th className="top">
                  <div className="folha1">
                    {renderProfissional()}
                    <h4 className="labels">
                      <b>{translate("screenApp.results.examDate")}: </b>{" "}
                      {formatedDate(data?.results[0]?.createdAt, true, true)}
                    </h4>
                    <h4 className="labels">
                      <b>{translate("screenApp.results.numberTest")}: </b>{" "}
                      {data?.testResultId}
                    </h4>
                    <h4 className="labels">
                      <b>{translate("screenApp.results.performedBy")}: </b>{" "}
                      {auth.user.nome}
                    </h4>
                  </div>
                </th>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div className="fix">
        <h4 className="fix">
          <b>{translate("screenApp.results.technicalManager")}: </b> Dr. Marcio
          Nakanishi CRM-DF 13.081
        </h4>
        <h4 className="fix">
          <b>{translate("screens.register.step3")}: </b> SGAS 610 BL I Sla S-2,
          Brasília - DF, 70200-700
        </h4>
      </div>
      <div>
        <b>
          {translate("screenApp.results.answer.score.title")}: {totalScore}
        </b>
      </div>
    </div>
  );

  const _renderResult = () => (
    <div className="container" style={{ color: "#000" }}>
      {_renderInfo()}
      <div className="folha">
        <h2>{translate("screenApp.results.detailing")}</h2>
        <table className="result">
          <tr className="result">
            <th className="result">
              {translate("screenApp.results.question")}
            </th>
            <th className="result">
              {translate("screens_quiz_labels_question")}
            </th>
            <th className="result">
              {translate("screens_quiz_labels_answer")}
            </th>
            <th className="result">
              {translate("screenApp_results_details_punctuation")}
            </th>
          </tr>
          {results?.map((item: any, index: any) => {
            return (
              <tr key={index} className="result">
                <td className="result">{index + 1}</td>
                <td className="result">{item.question}</td>
                <td className="result">{item.answer}</td>
                <td className="result">
                  {data.dataScore?.[index]?.score || 0}
                </td>
              </tr>
            );
          })}
        </table>
      </div>
    </div>
  );

  const Buttons = () => {
    return (
      <Stack spacing={2}>
        <Stack direction="row" spacing={2}>
          <IconButton onClick={handleClose} sx={{ color: "#000" }}>
            <Close />
          </IconButton>
        </Stack>
      </Stack>
    );
  };

  return (
    <div>
      <Modal
        open={openPDF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ transform: valueTransformIfRtl }}
      >
        <Box sx={style}>
          <PrintResult nameFile={namefile} ChildrenB={<Buttons />}>
            {_renderResult()}
          </PrintResult>
        </Box>
      </Modal>
    </div>
  );
}
